import React, { useEffect, useState } from 'react'
import CourseContent from './CourseContent'
import { useCourseReport } from '../context/CourseReportContext'
import { useUserReport } from '../context/UserReportContext'
import Button from '../../../../common/button/Button'

const CourseContentNavigation = ({ from = 'course-report' }) => {

    const { selectedUser, userDatum, courseDetails, selectedCourse } = from === 'course-report' ?  useCourseReport() : useUserReport()
    const [ currentContent, setCurrentContent ] = useState('lessons')

    useEffect(()=>{
        setCurrentContent('lessons')
    }, [ selectedCourse ] )

    const checkExist = ( type ) => {

        if( type === 'quiz'){
            const isObject = typeof userDatum === 'object'
            if( !isObject ) return false

            const hasKey = 'quiz' in userDatum.quizzes
            if( !hasKey ) return false
           
            if ( Object.keys( userDatum.quizzes.quiz ).length >= 0 && Object.values(userDatum.quizzes.quiz).some(item => item.course == selectedCourse.courseId)) return true
        }

    }
    const courseContents = [
        {
            type : 'lessons',
            title: 'Lessons',
            hasData: courseDetails.course_details.some(item => item.post_type === 'sfwd-lessons')
        },
        {
            type : 'topics',
            title: 'Topics',
            hasData: courseDetails.course_details.some(item => item.post_type === 'sfwd-topic')
        },
        {
            type : 'quizzes',
            title: 'Quizzes',
            hasData: checkExist( 'quiz' )
        },
        {
            type : 'assignments',
            title: 'Assignments',
            hasData: !userDatum.assignments || Object.values(userDatum.assignments).some(item => item.course_id == selectedCourse.courseId)
        }
    ]

    
    const renderComponent = () => {
        switch( currentContent ){
            case 'lessons':
                return (
                    <CourseContent key={selectedUser.userId+"lessons"} type={'lessons'} from={from} /> // need key to render changes
                )
            case 'topics':
                return (
                    <CourseContent key={selectedUser.userId+"topics"} type={'topics'} from={from} />
                )
            case 'quizzes':
                return (
                    <CourseContent key={selectedUser.userId+"quizz"} type={'quizzes'} from={from} />
                )
            case 'assignments':
                return (
                    <CourseContent key={selectedUser.userId+"assignment"} type={'assignments'} from={from} />
                )
            default: 
                return(
                    <div>
                        Invalid type
                    </div>
                )
        }
    }

    useEffect(()=>{
        renderComponent()
    },[ selectedUser ])

    return (
        <>
            <div className='msync-reporting__detail__navigation'>
                <span className='msync-reporting__detail__navigation__label'>Course Content</span>
                <ul className='msync-reporting__detail__navigation__nav msync-card__navigation'>
                    {
                        courseContents.map((content, key) => {
                        
                            return (
                                <li>
                                    <Button
                                        className={`msync-button--is-style-link${currentContent === content.type ? ' active' : ' msync-button--is-theme-secondary'}`} 
                                        onClick={() => content.hasData && setCurrentContent(content.type)}
                                        isDisabled={!content.hasData && true}
                                    >
                                        <span>{!content.hasData && "No "}{content.title}</span>
                                    </Button>
                                </li>
                            )
                        })
                    }
                </ul>
            </div>
            <div className='msync-reporting__detail__data'>
                {
                    renderComponent()
                }        
            </div>
        </>
    )
}

export default CourseContentNavigation